import React from 'react'

const English = () => {
  return (
    <div>
      English
      English
    </div>
  )
}

export default English
